import { AdAccountByOrgIdData } from '../../apis/graphql/accountManagement/adAccount/useGetAdAccountsByOrgId/useGetAdAccountsByOrgId';
import { BrandItem } from '../../apis/graphql/user/useFetchAdAccountByUser/useFetchAdAccountByUser';
import { RoutePath } from '../../constants';
import { adGalleryAdAccountTitle, defaultAdAccountTitle } from './constants';

export const getDisableTitle = (pathName: string): string => {
  return pathName.includes(RoutePath.AD_GALLERY || RoutePath.REPORTS) ? adGalleryAdAccountTitle : defaultAdAccountTitle;
};

export const getBrandsWithAdAccounts = (adAccountList: AdAccountByOrgIdData): BrandItem[] => {
  const brands: { [key: string]: BrandItem } = {};

  adAccountList.forEach((item) => {
    if (item?.brand) {
      const currentBrand = brands[item.brand.id];
      const adAccount = { id: item.id, label: item.name, isBaymaxEnabled: item.isBaymaxEnabled || false };

      brands[item.brand.id] = {
        ...(currentBrand || { id: item.brand.id, name: item.brand.name }),
        accountList: currentBrand ? [...currentBrand.accountList, adAccount] : [adAccount],
      };
    }
  });

  return Object.values(brands);
};
